import { useState, useEffect } from "react";

const useAllActiveEvents = () => {
  const [allEvents, setAllEvents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoader] = useState(false);

  const fetchAllEvents = async () => {
    setLoader(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("No token found");
        setLoader(false);
        return;
      }
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );

      if (!res.ok) {
        throw new Error("Failed to fetch events");
      }
      const data = await res.json();
      setAllEvents(data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAllEvents();
  }, []);

  return {
    loading,
    allEvents,
    error,
  };
};

export default useAllActiveEvents;
